// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeholderLoader{0%{background-position:-500px 0}to{background-position:500px 0}}.article-header{margin-left:auto;margin-right:auto;max-width:800px}.article-header__author{display:inline-block;font-size:clamp(1rem,.89rem + .36vw,1.25rem);line-height:1.3}.article-header__author a{font-weight:800}.article-header__author span:before{content:\"/\";font-weight:800}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
